/* Component in the Scene Component to fetch 
   all ShotList data for a Scene
 * Contains the Shot component to which it passes the data
   for each Shot in the Shotlist
 * Contains the ShotListCreate component  */
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import styles from "../../../styles/Scene.module.css";
import btnStyles from "../../../styles/Button.module.css";
import ShotListCreate from "./ShotListCreate";
import Shot from "./Shot";
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config";
import useHostName from "../../../hooks/useHostName";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import InfoShot from "../info/InfoShot";
import { toast } from "react-hot-toast";


const ShotlistPage = ({ scene, setShowlist }) => {
  const currentUser = useCurrentUser();
  const roleName = currentUser?.groups?.[0]?.name;
  const canDragReorder = roleName === "Superadmin";
  const host = useHostName();
  const { id } = useParams();
  const [showInfo, setShowInfo] = useState(false);
  const [addShot, setAddShot] = useState(false);
  const [abortBlockedDrag, setAbortBlockedDrag] = useState(false);
  const [shotlist, setShotlist] = useState({ results: [] });
  const handleMount = async () => {
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosReq(`/shotlists/?scene_id=${id}`);
        setShotlist(data);
        setIsSavingOrder(false)
      } else {
        // &ordering=day_order_number
        const { data } = await axiosInstance(`${localStorage.getItem("projectSlug")}/shotlists/?scene_id=${id}`);
        setShotlist(data);
        setIsSavingOrder(false)
      }
    } catch (err) {
      console.log(`err ${err}`);
    }
  };

  useEffect(() => {
    handleMount();
    // eslint-disable-next-line
  }, [id , addShot]);

  const [isDragging, setIsDragging] = useState(false);
  const [isSavingOrder, setIsSavingOrder] = useState(false);

  const [shotId, setShortId] = useState({ id: '', scene_id: '' })
  const handleDragEnd = async (result) => {
    if (!canDragReorder) {
      setIsDragging(false);
      setAbortBlockedDrag(false);
      return;
    }
    setIsDragging(false);
    if (!result.destination) return;

    const updatedResults = Array.from(shotlist.results);
    const [movedItem] = updatedResults.splice(result.source.index, 1);
    updatedResults.splice(result.destination.index, 0, movedItem);

    // // Optimistically update the UI
    setShotlist((prev) => ({
      ...prev,
      results: updatedResults,
    }));

    try {
      setIsSavingOrder(true);
      const newIndex = result.destination.index;
      const sourceID = result.source.index;
      // const movedShot = updatedResults[newIndex];

      const apiURL =
        host === CLIENT_PROGRAM_HOSTNAME
          ? `/shotlists/bulk-ordering/`
          : `${localStorage.getItem("projectSlug")}/shotlists/bulk-ordering/`;

      await axiosInstance.post(
        apiURL,
        {
          order_number: newIndex,
          left_number: sourceID,
          shortlist_id: shotId?.id,
          scene_id: shotId?.scene_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      );
      handleMount();
    } catch (error) {
      console.error("Error updating moved shot", error);
    }
    finally {
      setIsSavingOrder(false);
    }

  };

  return (
    <div className="mb-5">
      <Row>
        <Col xs={12} className="text-center">
          <h5 className={`pl-5 py-1 ${styles.SubTitle}`}>
            SHOTLIST
            <span
              style={{ textTransform: "none" }}
              className={`float-right ${styles.Close} pt-md-1`}
              onClick={() => setShowlist(false)}
            >
              Close
            </span>
          </h5>
        </Col>
      </Row>
      {/* info md */}
      <div className="d-none d-md-block">
      {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin") && (
      <Row className="my-1">
      <Col md={2} ></Col>
      <Col className="text-center" xs={8}>
              <p className={`text-center ${styles.Small}`}>USE 
        DRAG AND DROP TO REORDER SHOTS</p>
      </Col>
      <Col className="text-center" xs={2}>
      <Button
          className={`float-right px-4 py-0 ${btnStyles.Order} ${btnStyles.Button}`}
          onClick={() => setShowInfo(showInfo => !showInfo)} >INFO
      </Button> 
      </Col>
      </Row>
            )}
      </div>
      {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin") && (
      <Row className="d-flex align-items-center my-1">
        <Col xs={2} ></Col>
        <Col className="text-center" xs={8} >
              <Button
                onClick={() => setAddShot((addShot) => !addShot)}
                className={`${btnStyles.Button} ${btnStyles.Bright} px-5`}
              >
                Add Shot
              </Button>
        </Col>
        <Col xs={2} >
        <Button
          className={`d-block d-md-none float-right px-2 py-0 ${btnStyles.Order} ${btnStyles.Button}`}
          onClick={() => setShowInfo(showInfo => !showInfo)} >INFO
      </Button> 
        </Col>
      </Row>)}
      {!showInfo ? (
      ""
          ) : (
              <InfoShot  /> 
      )}
      {!addShot ? (
            ""
          ) : (
            <ShotListCreate
              setAddShot={setAddShot}
              setShotlist={setShotlist}
              handleMount={handleMount}
              scene={scene}
            />
          )}
      {/* titles */}
      <div className="d-none d-md-block">
        <Row
          style={{ textTransform: "uppercase" }}
          className={`mt-3 ${styles.TitleBox} text-center mx-0`}
        >
          <Col className={`px-0 ${styles.TitleBox2} `} xs={1} md={1}>
            <p className="mb-0">Info</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">#</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">Size</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">Frame</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={4} md={4}>
            <p className="mb-0">Description</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">Angle</p>
          </Col>
          <Col className={`px-0  ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0">Move</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} 
          xs={(currentUser?.groups[0]?.name === "Superadmin" ) ? 1 : 2}
          md={(currentUser?.groups[0]?.name === "Superadmin" ) ? 1 : 2}
              >
            <p className="mb-0">Image</p>
          </Col>
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin" ) && (
            <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
                <p className="mb-0">Edit</p>
              </Col>
              )}
        </Row>
      </div>
      {/* mobile */}
      <div className="d-block d-md-none">
        <Row
          style={{ textTransform: "uppercase" }}
          className={`mt-2 ${styles.TitleBox} text-center mx-0`}
        >
          <Col className={`px-0 ${styles.TitleBox2} `} xs={1} md={1}>
            <p className={`ml-1 mb-0`}>In</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={1} md={1}>
            <p className="mb-0"># </p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={2} md={2}>
            <p className="mb-0">Sz/Fr</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`}
          xs={(currentUser?.groups[0]?.name === "Superadmin" ) ? 4 : 5}
          md={(currentUser?.groups[0]?.name === "Superadmin" ) ? 4 : 5}
           >
            <p className="mb-0">Detail</p>
          </Col>
          <Col className={`px-0 ${styles.TitleBox2}`} xs={3} md={3}>
            <p className="mb-0">Ang/Mv</p>
          </Col>
          {/* edit */}
          {currentUser &&
            currentUser?.groups.length > 0 &&
            (currentUser?.groups[0]?.name === "Superadmin") && (
          <Col className={`px-0 ${styles.TitleBox2} `} xs={1} md={1}>
            <p className="pl-1 mb-0"></p>
          </Col>
        )}
        </Row>
      </div>
      {/* shots */}
      <Row className="w-100 position-relative">
        <DragDropContext onDragEnd={handleDragEnd}
          onDragStart={(start) => {
            if (!canDragReorder) {
              toast.error("You are not authorized to drag and drop.");
              setAbortBlockedDrag(true);
              return;
            }
            const draggedItem = shotlist?.results?.find(
              (item) => String(item.id) === start.draggableId
            );
            if (draggedItem) {
              setShortId({ id: draggedItem.id, scene_id: draggedItem.scene_id })
              setIsDragging(true);
            }
          }}

        >
          {(isDragging || isSavingOrder) && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1000,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(255, 255, 255, 0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden"></span>
              </div>
            </div>
          )}
          <Droppable droppableId="shotlist-droppable">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef} className="w-100" style={{ width: "100%", position: 'relative', left: '15px' }}>
                {shotlist?.results?.map((shot, index) => (
                  <Draggable
                    key={shot.id}
                    draggableId={String(shot.id)}
                    index={index}
                    isDragDisabled={!canDragReorder && abortBlockedDrag}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                      >
                        <Shot
                          style={{
                            backgroundColor:
                              index % 3 === 0
                                ? "#dbfaf9"
                                : index % 2 === 0
                                  ? "rgb(232, 246, 231)"
                                  : "rgb(248 241 249)",
                          }}
                          key={shot.id}
                          handleMount={handleMount}
                          shotAll={shot}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Row>
      {/* break */}
      <Row className='my-5'>
      <Col xs={2} ></Col>
      <Col xs={8}>
      <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
      <hr className={`${styles.BreakBlack} my-0`}/>
      </Col>
      </Row>
    </div>
  );
};

export default ShotlistPage;
